import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { ArnModule } from './app/arn.module';

platformBrowserDynamic()
  .bootstrapModule(ArnModule)
  .catch((err) => console.error(err));
